import DOMPurify from "dompurify";

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["p", "br", "strong", "em", "u", "s", "ul", "ol", "li", "h1", "h2", "h3", "blockquote", "a", "img", "span", "code", "pre"],
    ALLOWED_ATTR: ["href", "src", "alt", "class", "target", "rel"],
  });
}
